import { createHttpEndpoint } from '../../utils'

import type { GetBackPricerStatus } from './backpricer.types'

/**
 * Get backpricer status for authenticated merchant
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/seller-merchants-api/definition#tag/Backpricer/operation/get-bm-merchants-backpricer}
 */
export const getBackPricerStatus = createHttpEndpoint<GetBackPricerStatus>({
  method: 'GET',
  operationId: 'getBackPricerStatus',
  path: '/bm/merchants/backpricer',
})

/**
 * Update the backpricer status for the authenticated merchant
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/seller-merchants-api/definition#tag/Backpricer/operation/post-bm-merchants-backpricer}
 */
export const updateBackPricerStatus = createHttpEndpoint({
  method: 'POST',
  operationId: 'updateBackPricerStatus',
  path: '/bm/merchants/backpricer',
})
